import { Mic } from 'lucide-react'

export default function ReadyToRecord({ clientName, kindLabel, onStart, onCancel, error }) {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-12">
      <div className="mb-2 text-[11px] uppercase tracking-[.4px] text-muted">{kindLabel}</div>
      <h1 className="mb-1 text-[22px] font-semibold tracking-[-0.02em]">{clientName}</h1>
      <p className="mb-10 max-w-[340px] text-center text-[13.5px] text-muted">
        Prêt à enregistrer. Le micro et la transcription démarrent au clic.
      </p>

      <button
        onClick={onStart}
        aria-label="Démarrer l'enregistrement"
        className="group relative flex h-28 w-28 items-center justify-center rounded-full bg-terra-500 text-white shadow-[0_18px_40px_rgba(181,73,31,.28)] transition-transform hover:scale-[1.03] active:scale-[0.98]"
      >
        <span className="pointer-events-none absolute inset-0 rounded-full border border-terra-500 opacity-40 animate-ripple" />
        <span className="pointer-events-none absolute inset-0 rounded-full border border-terra-500 opacity-30 animate-ripple" style={{ animationDelay: '0.8s' }} />
        <Mic size={36} strokeWidth={2} />
      </button>

      <div className="mt-6 text-[12.5px] font-medium uppercase tracking-[.3px] text-ink">Démarrer</div>
      <div className="mt-1 text-[11.5px] text-muted">0:00</div>

      {error && (
        <div role="alert" className="mt-6 max-w-[340px] rounded-lg border border-terra-500/40 bg-terra-50 px-4 py-3 text-center text-[12.5px] text-terra-600">
          {error}
        </div>
      )}

      <button
        onClick={onCancel}
        className="mt-10 text-[12.5px] text-muted underline-offset-2 hover:text-ink hover:underline"
      >
        Annuler
      </button>
    </div>
  )
}
